<div class="cell-content" [ngSwitch]="column.type">
  <div class="cell-title-mobile">
    <mat-label [innerHTML]="column.label | translate"></mat-label>
  </div>
  <nc-select-cell [class]="alignClass" *ngSwitchCase="columnType.SELECT_COLUMN" [column]="column"
                  [rowData]="rowData"></nc-select-cell>
  <nc-action-cell *ngSwitchCase="columnType.ACTION_COLUMN" [column]="column" [rowData]="rowData"></nc-action-cell>
  <nc-checkbox-cell *ngSwitchCase="columnType.CHECKBOX_COLUMN" [rowData]="rowData" [selectConfig]="selectConfig"></nc-checkbox-cell>
  <span *ngSwitchDefault [class]="alignClass">
      {{rowData[column.name] | translate}}
  </span>
</div>
